import { useSkuSelector } from '../hooks/useSkuSelector';

type SkuSelectorSubContainerProps = { children: React.ReactNode; type: string };

const SkuSelectorSubContainer = ({ children, type }: SkuSelectorSubContainerProps) => {
	const { variationsSpacing } = useSkuSelector();

	return (
		<div
			className={`skuSelectorSubcontainer skuSelectorSubcontainer--${type} flex flex-column vtex-store-components-3-x-skuSelectorSubcontainer--${type} mb${variationsSpacing} vtex-store-components-3-x-skuSelectorSubcontainer`}
		>
			<div className={`skuSelectorNameContainer vtex-store-components-3-x-skuSelectorNameContainer ma1`}>
				{children}
			</div>
		</div>
	);
};

export default SkuSelectorSubContainer;
